<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:09
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-10-10 10:58:36
 * @FilePath: \ces-vue-serve\src\views\orderPersion\complete\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'orderPersionContractList' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info-view :contract-num="contractNum" :is-show-esing="isShowEsing" @initInfo="initInfo" />
    <!-- 筛选SBG国内逻辑，SBG国内订单不展示。SBG国内:"部门名称"包含"SBG"或"SMB"或"家庭互联"字段,且"订单分类"不包含"国际" -->
    <!-- 部门编码 000063(SBG)、000036(SMB)、000101（家庭互联） -->
    <orderProcess v-if="isInternational" :contract-num="contractNum" :info="info" />
    <!-- {{ info }} -->
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="合同明细">
        <productDetail2 :contract-id="info.id" :str-contract-code="contractNum" :contract-type="info.contractType" :special-product="info.specialProduct" :special-cloud-desc="info.specialCloudDesc" :multiaddress-value="info.multiaddressValue" :multiaddress="info.multiaddress" />
      </rj-tab-pane>
      <rj-tab-pane name="10" label="订单明细">
        <contractual-product :str-contract-code="contractNum" :init-info="info" :sales-type="info.salesType" />
      </rj-tab-pane>
      <rj-tab-pane name="7" label="约定交付日期">
        <delivery-date :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="发货明细">
        <logistics-info :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="6" label="序列号明细">
        <serial-number id="" :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="4" label="开票明细">
        <invoice-details :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="3" label="销退明细">
        <extinction-details :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="5" label="分配明细">
        <pay-for-details v-if="info.id" :contract-id="info.id" :contract-status="info.contractStatus" />
      </rj-tab-pane>
      <rj-tab-pane name="8" label="分批发货明细">
        <partShipment
          v-if="info.id"
          :contract-id="info.id"
          :contract-status="info.contractStatus"
          :is-direct-order="isDirectOrder"
        />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import contractualProduct from '../../Chief/contract/common/contractualProduct';
import baseInfoView from './baseInfo';
import partShipment from './partShipment';
import serialNumber from '../../Chief/contract/common/serialNumber';
import payForDetails from '../../Chief/contract/common/payForDetails';
import extinctionDetails from '../../Chief/contract/common/extinctionDetails';
import InvoiceDetails from '../../Chief/contract/common/InvoiceDetails';
import deliveryDate from '../../Chief/contract/common/deliveryDate';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import logisticsInfo from '../../Chief/contract/common/logisticsInfo';
import productDetail2 from '../../Chief/contract/common/productDetail2';
import orderProcess from './order-process/index.vue';

export default {
  data () {
    return {
      tabsActive: '1',
      info: {
        // 初始化所在部门编码 为空字符串，防止v-if 模版编译报错，
        departmentCode: ''
      }
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    contractualProduct,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    logisticsInfo,
    serialNumber,
    baseInfoView,
    extinctionDetails,
    InvoiceDetails,
    payForDetails,
    deliveryDate,
    partShipment,
    productDetail2,
    orderProcess
  },
  computed: {
    // 是否是直签合同
    isDirectOrder () {
      if (this.info?.integratorParticipate === false && this.info?.distributorParticipate === false) {
        return true;
      }
      return false;
    },
    isShowEsing () {
      // 如果是新ECP && 是服务订单就展示
      return this.info.sources === 'NEW-ECP' && this.info.contractType === '服务订单';
    },
    // 是否国际
    isInternational () {
      return !(['国际业务下单', '国际分销下单'].includes(this.info.contractType) || (this.info.contractType === '服务订单' && this.info.civilInternational)) && !['000063', '000036', '000101'].includes(this.info.departmentCode.slice(0, 6));
    }
  },
  methods: {
    initInfo (info) {
      this.info = info;
      // console.log('订单信息===========', info?.strSalesType, info?.contractType, info.departmentName, info.departmentCode);
    },
    nameLocation () {
      let isdisabled = this.$route.query.isdisabled;
      if (!isdisabled) {
        this.tabsActive = '8';
      }
    }
  },
  created () {
    this.nameLocation();
  }
};
</script>
